import React from 'react'
import classes from './CollectFeesModal.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { setLoader, setOpenFeeCollection } from '../../../../../../../redux/globalSlice'
import StudentBox from '../../../../../../../common/StudentBox/StudentBox'
import { Box, Modal, Typography } from '@mui/material'
import TextField from '../../../../../../../components/TextField/Textfield'
import { toast } from 'react-toastify'
import axios from 'axios'
import { baseURL, urls } from '../../../../../../../shared/config'
import { SelectField } from '../../../../../../../components'
const CollectFeesModal = ({ userSchoolId, refetch }) => {
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 471,
    bgcolor: 'background.paper',
    border: 'none',
    boxShadow: 24,
    p: 4,
    outline: 'none',
    borderRadius: '24px', // optional: looks better
  }
  const [formValues, setFormValues] = React.useState({
    payment_id: '',
    discount_fee: 0,
    month: '',
  })

  const open = useSelector((state) => state.global.openFeeCollection)
  const dispatch = useDispatch()
  const handleClose = () => dispatch(setOpenFeeCollection(false))
  const school_fee_method = localStorage.getItem('school_fee_method')

  const SchoolDInfo = useSelector((state) => state.global.SchoolDInfo)
  const getCurrentMonthCapitalized = () => {
    const date = new Date()
    const monthName = date.toLocaleString('default', { month: 'long' })
    return monthName.charAt(0).toUpperCase() + monthName.slice(1)
  }

  const currentMonth = getCurrentMonthCapitalized()

  // console.log('----transport_fee',SchoolDInfo);

  // console.log('----SchoolDInfo', SchoolDInfo)
  const validatePaymentId = (value) => {
    if (!value?.trim()) {
      return 'Payment ID is required'
    }
    return ''
  }

  const handleChange = (e) => {
    const value = e.target.value
    setFormValues((prev) => ({ ...prev, payment_id: value }))
  }

  const handleSubmit = async () => {
    dispatch(setLoader(true))
    const trimmed = formValues?.payment_id?.trim()

    if (!trimmed) {
      toast.error('Payment ID cannot be empty')
      return
    }
    const responseBody = {
      payment_id: formValues.payment_id,
      transport_fee: SchoolDInfo?.student_transport_fee,
      school_id: userSchoolId,
      student_id: SchoolDInfo?.student_id,
      batch_year: SchoolDInfo?.student_batch_year,
      last_year_due_fee: 0,
      misc_fee: 0,
      exam_fee: 0,
      tuition_fee: 0,
      monthly_discount: 0,
      month: formValues.month || currentMonth,
      fee_method: school_fee_method,
    }
    try {
      const response = await axios.post(`${baseURL}${urls.ADD_FEE}`, responseBody)
      if (response?.data?.status === 200 || response?.data?.status === 201) {
        toast.success('fees is submitted')
        handleClose()
      }
    } catch (error) {
      console.error('error submitting error', error)
      handleClose()
    } finally {
      refetch()
      dispatch(setLoader(false))
    }
  }
  const monthOptions = [
    { label: 'January', value: 'January' },
    { label: 'February', value: 'February' },
    { label: 'March', value: 'March' },
    { label: 'April', value: 'April' },
    { label: 'May', value: 'May' },
    { label: 'June', value: 'June' },
    { label: 'July', value: 'July' },
    { label: 'August', value: 'August' },
    { label: 'September', value: 'September' },
    { label: 'October', value: 'October' },
    { label: 'November', value: 'November' },
    { label: 'December', value: 'December' },
  ]
  const handleMonthChange = (selectedValue) => {
    // console.log("what onChange actually received:", selectedValue);

    setFormValues((prev) => ({
      ...prev,
      month: selectedValue || '', // ← no .value
    }))
  }

  // console.log('---asd', formValues.month)

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div className={classes.container}>
          <div className={classes.top}>
            <p className="modalheadtxt">Confirmation</p>
            <p className={classes.description}>
              Are you sure you want to collect the Transport fees from the student? Please confirm
              to proceed.
            </p>
          </div>
          <div className={classes.vanbox}>
            <StudentBox
              student_avatar={''}
              student_grade={SchoolDInfo?.grade_name}
              student_name={SchoolDInfo?.student_name}
              student_section={SchoolDInfo?.section_name}
            />
            <p className={classes.money}>{SchoolDInfo?.student_transport_fee}</p>
          </div>
          <TextField
            placeholder="Enter Payment ID / Transaction ID"
            value={formValues.payment_id}
            onChange={handleChange}
            label="Payment ID"
            required={true}
            width="100%"
          />
          {school_fee_method !== 'Annually' && (
            <SelectField
              label={'Month'}
              required
              options={(monthOptions || [])?.map((prod) => ({
                value: prod.value,
                label: prod.label,
              }))}
              width={'100%'}
              name="month"
              value={formValues?.month}
              onChange={handleMonthChange}
            />
          )}

          {/* <TextField
            placeholder={''}
            value={formValues?.discount_fee}
            onChange={(selectedOption) =>
              setFormValues({ ...formValues, discount_fee: selectedOption })
            }
            label={'Discount Fee'}
            required={true}
            width={'100%'}
          /> */}
          <div className={classes.bottom}>
            <button onClick={handleClose} className={`${classes.flex} white-button`}>
              {'Cancel'}
            </button>

            <button
              onClick={handleSubmit}
              disabled={!formValues.payment_id.trim()}
              className={`${classes.flex} primary-button`}
            >
              {'Confirm'}
            </button>
          </div>
        </div>
      </Box>
    </Modal>
  )
}

export default CollectFeesModal
